
window.addEventListener('load', function () {
    iniciarMapa();
    /*Setear keyup en campo cp*/
    var cp = document.getElementById("cp");
    if(cp)cp.addEventListener("keyup", function(){
        if(this.value.length==5){
            setDomicilioAjax(this.value);
        }
    }, false);
    /*Botón de pintar marcador*/
    var btn_ubicacion = document.getElementById("btn_ubicacion");
    if(btn_ubicacion)btn_ubicacion.addEventListener("click", function(){
        setMarcardor();
    }, false);
    /*Ajax buscar domicilio*/
    setDomicilioAjax=function(cp,colonia=null){
        var token = document.head.querySelector('meta[name="csrf-token"]');
        var url = url_base;
        axios.post(url+'/api/domicilio',{
            cp: cp,
            _token: token.content
        })
            .then(response => {
                var domicilio=response.data.domicilio;
                var select=response.data.colonias;
                if((response.data.mensaje)&&(response.data.mensaje=="resultados")){
                    document.getElementById('btn_ubicacion').disabled = false;
                    document.getElementById('estado').value=domicilio.d_estado;
                    document.getElementById('codigo_estado').value=domicilio.codigo_estado;
                    document.getElementById('municipio_alcaldia').value=domicilio.d_mnpio;
                    document.querySelector('.div-colonia-cp').innerHTML='';
                    document.querySelector('.div-colonia-cp').innerHTML=select;
                    $('.div-colonia-cp>select').selectpicker();
                    /*Habilita input al seleccionar otra colonia*/
                    $('.select-colonia').on('change',function() {
                        if($(this).selectpicker('val')=='otra'){
                            document.querySelector('.div-colonia-cp').innerHTML='';
                            document.querySelector('.div-colonia-cp')
                                .innerHTML='<input type="text" class="form-control" placeholder="Escribe el nombre de otra colonia" name="colonia" id="colonia">';
                        }
                    });
                    if(colonia) document.querySelector('#colonia').value=colonia;
                }else{
                    document.getElementById('btn_ubicacion').disabled = true;
                    document.getElementById('estado').value='';
                    document.getElementById('codigo_estado').value='';
                    document.getElementById('municipio_alcaldia').value='';
                    document.querySelector('.div-colonia-cp').innerHTML='';
                    document.querySelector('.div-colonia-cp')
                        .innerHTML='<input type="text" class="form-control" placeholder="Escribe el nombre de la colonia" name="colonia" id="colonia">';
                }
            })
            .catch(e => {
                console.log(e);
            });
    }
});

/*Funciones de google maps*/
infowindow = new google.maps.InfoWindow({
    content: 'Lugar'
});

var map=false,geocoder=false,marker=false;
setMarcardor=function(lat=null,long=null){
    if(marker)marker.setMap(null);
    var domicilio="";
    domicilio+=document.getElementById('calle').value!=""?document.getElementById('calle').value:'';
    domicilio+=document.getElementById('no_exterior').value!=""?" "+document.getElementById('no_exterior').value:'';
    domicilio+=document.getElementById('colonia').value!=""?", "+document.getElementById('colonia').value:'';
    domicilio+=document.getElementById('cp').value!=""?" "+document.getElementById('cp').value:'';
    domicilio+=document.getElementById('municipio_alcaldia').value!=""?", "+document.getElementById('municipio_alcaldia').value:'';
    domicilio+=document.getElementById('estado').value!=""?", "+document.getElementById('estado').value:'';
    geocoder.geocode( { 'address': domicilio}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            if(results[0]){
                $('#btn_registrar_domicilio').attr('disabled',false);
                var latitude = lat ?? results[0].geometry.location.lat();
                var longitude = long ?? results[0].geometry.location.lng();
                map.setCenter({lat: latitude, lng: longitude});
                document.getElementById('latitud').value=latitude;
                document.getElementById('longitud').value=longitude;
                map.setZoom(15);
                marker = new google.maps.Marker({
                    position: {lat: latitude, lng: longitude},
                    title: "Ubicación",
                    map: map,
                    draggable: true,
                    animation: google.maps.Animation.DROP,
                    //icon: document.getElementById("url").value+'/images/icons/marcador.svg'
                });
                marker.addListener("dragend", function (){
                    var ubicacion=marker.getPosition(); //OBTIENE UBICACIÓN DEL MARCADOR
                    document.getElementById('latitud').value=ubicacion.lat();
                    document.getElementById('longitud').value=ubicacion.lng();
                });
                infowindow.open(map, marker);
            }
            else {
                alert('Sin resultados');
            }
        }
    });
    google.maps.event.trigger(map, "resize");
}
iniciarMapa=function() {
    var div_mapa=document.getElementById('div_map');
    var latitud=document.getElementById('latitud');
    var longitud=document.getElementById('longitud');
    if(div_mapa){
        map = new google.maps.Map(div_mapa, {
            scrollwheel: false,
            center: {lat: 21.473296, lng: -104.855824},
            zoom: 14
        });
        geocoder = new google.maps.Geocoder;
    }
    if((latitud&&longitud)&&(latitud.value!=""&&longitud.value!="")){
        setMarcardor(parseFloat(latitud.value),parseFloat(longitud.value));
    }

    $('#municipio_alcaldia').autoComplete({
        resolver:'custom',
        bootstrapVersion:"4",
        events: {
          search:function (qry, callback) {
            $.ajax({
              url: url_base+"/api/municipioAutocomplete",
              dataType: 'json',
              data: {
                'qry': qry
              },
              beforeSend: function(){
              },
              error: function(){
                console.error("error");
              },
              success: function(data){
                callback(data);
              }
            });
          }
        }
      }).on('autocomplete.select',function (evt, item) {
        $("#form_domicilio").find("#estado").val(item.obj.d_estado);
        $("#form_domicilio").find("#cp").val(item.obj.d_codigo);
        $("#form_domicilio").find("#municipio_alcaldia").val(item.obj.d_mnpio);
        cargarColonias(item.obj);

      });
      cargarColonias = function(obj,colonia=null){
          var token = $('meta[name="csrf-token"]').attr('content');
          $.ajax({
              url: url_base+"/api/getColonias",
              method: 'POST',
              data: {
                  _token:token,
                  id:obj.id_asenta_cpcons,
                  estado: obj.d_estado
              },
              dataType: 'json',
              beforeSend: function(){
              },
              error: function(){
                  console.error("error");
              },
              success: function(result){
                var select = result.colonias;
                console.log(result);
                if((result.mensaje)&&(result.mensaje=="resultados")){
                    document.querySelector('.div-colonia-cp').innerHTML='';
                    document.querySelector('.div-colonia-cp').innerHTML=select;
                    $('.div-colonia-cp>select').select2({theme: "bootstrap",placeholder: 'Seleccione...'});
                    getCodigoPostal();
                    /*Habilita input al seleccionar otra colonia*/
                    $('.select-colonia').on('change',function() {
                        if($(this).selectpicker('val')=='otra'){
                            document.querySelector('.div-colonia-cp').innerHTML='';
                            document.querySelector('.div-colonia-cp')
                                .innerHTML='<input type="text" class="form-control" placeholder="Escribe el nombre de otra colonia" name="colonia" id="colonia">';
                        }
                    });
                    if(colonia) document.querySelector('#colonia').value=colonia;
                    }else{
                        document.querySelector('.div-colonia-cp').innerHTML='';
                        document.querySelector('.div-colonia-cp')
                            .innerHTML='<input type="text" class="form-control" placeholder="Escribe el nombre de la colonia" name="colonia" id="colonia">';
                    }
                }
            });
      }
      getCodigoPostal = function(){
        var opt = $('.select-colonia').find(':selected').get();
        if(opt.length === 1){
            var cp = opt[0].dataset.cp;
            $('#cp').val(cp);
        }
      }
}
